export enum CcsSkeletonRadiusEnum {
  none = 'none',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  '2xl' = '2xl',
  '3xl' = '3xl',
  full = 'full',
}
